import { GetServerSideProps } from 'next';
import React from 'react';
import Layout from '../../components/Layout/Layout';
import OfferingsPageComponent from '../../components/Solutions/Insurance/OfferingsPageComponent';
import { apiRequest } from '../../components/util/requests/requests';
import { PageMetadata } from '../../components/util/SeoMetaInformationComponent/SeoMetaInformationComponent';

export interface OfferingsProps {
    pageMetadata?: PageMetadata;
}

export const getServerSideProps: GetServerSideProps = async ({ params }) => {
    const pageMetadata = await apiRequest(
        '/meta-pages?filters[key]=SOLUTIONS_OFFERINGS_PAGE&populate[0]=seo'
    );

    return {
        props: {
            pageMetadata:
                pageMetadata.data && pageMetadata.data.length > 0 ? pageMetadata.data[0] : null,
        },
    };
};

const Offerings = ({ pageMetadata }: OfferingsProps) => (
    <Layout seoMetadata={pageMetadata?.seo} defaultMetaTitle={'Noria.no - Solutions - Offerings'}>
        <OfferingsPageComponent />
    </Layout>
);

export default Offerings;
